import { useEffect, useState } from 'react';
import AuthHeader from './AuthHeader';
import AuthForm from './AuthForm';
import usePostData from 'hooks/usePostData';
import translating from '../translate.json';
import SnackBar from 'components/SnackBar';

const ForgotPasswordForm = () => {
  const { error, postData, res } = usePostData();
  const [errFun, setErrFun] = useState(null);
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        message: error.apiError
      });
    else if (res) setShowSnakbar(true);
  }, [error, res]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    sessionStorage.setItem('emailMvmt', data.email);
    postData('auth/forgotPassword', data);
  };

  const sendAgain = () => {
    postData('auth/forgotPassword', {
      email: sessionStorage.getItem('emailMvmt')
    });
  };

  const fields = [
    {
      name: 'email',
      label: translating.email,
      pattern: {
        value:
          '/^(([^<>()[]\\.,;:s@"]+(.[^<>()[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/',
        message: translating.emailFormatErrMsg
      },
      placeholder: translating.typeEmail
    }
  ];

  return (
    <div className="forgot-password-form">
      <AuthHeader
        title={translating.forgotPasswordTitle}
        description={translating.forgotPasswordDescription}
      ></AuthHeader>
      <AuthForm
        fields={fields}
        link={{
          text: translating.forgotEmailSendAgain,
          handleClickLink: sendAgain,
          hidden: !sessionStorage.getItem('emailMvmt')
        }}
        handleClickSubmit={onSubmit}
        submitTxt={translating.send}
      ></AuthForm>
      {showSnackbar && (
        <SnackBar
          msg={translating.mailSent}
          handleClose={() => {
            setShowSnakbar(false);
          }}
        ></SnackBar>
      )}
    </div>
  );
};

export default ForgotPasswordForm;
